import { useAppStore } from '@/store/store';
import { selectPalletLoad } from '@/store/selectors';

export function PalletPanel() {
  const palletLoad = useAppStore(selectPalletLoad);
  const packages = useAppStore((s) => s.packages);
  const hasPackages = packages.some((p) => p.length > 0 && p.width > 0 && p.height > 0);

  return (
    <div className="card" data-testid="pallet-panel">
      <h3 className="section-title">Pallet Configuration</h3>
      {!hasPackages ? (
        <p style={{ color: 'var(--color-text-muted)' }}>
          Enter package dimensions on the Calculator tab first.
        </p>
      ) : (
        <div className="metric-grid">
          {palletLoad.map((fit) => (
            <div key={fit.palletType} className="metric-box">
              <div style={{ fontWeight: 'var(--font-weight-semibold)', marginBottom: 'var(--space-2)' }}>
                {fit.palletType}
              </div>
              <div className="text-sm text-secondary">
                <div>Cartons/layer: {fit.cartonsPerLayer}</div>
                <div>Layers: {fit.layers}</div>
                <div>Total cartons: <strong>{fit.totalCartons}</strong></div>
                <div>Utilization: {fit.volumeUtilization.toFixed(1)}%</div>
                <div>Pallets needed: <strong>{fit.palletCount}</strong></div>
                <div style={{ marginTop: 'var(--space-1)' }}>
                  <span
                    title={fit.weightLimitedBy === 'weight' ? 'Height-based layers exceeded by weight limit' : undefined}
                    className="metric-label"
                    style={{
                      display: 'inline-block',
                      padding: '2px var(--space-2)',
                      borderRadius: 'var(--radius-sm)',
                      background: fit.weightLimitedBy === 'weight' ? 'var(--color-bg-primary)' : 'transparent',
                      color: fit.weightLimitedBy === 'weight' ? 'var(--color-warning)' : 'var(--color-text-muted)',
                    }}
                  >
                    Limited by: {fit.weightLimitedBy}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
